var _circle, _circle2, _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _path3, _path4, _line7, _path5, _line8, _path6, _line9, _path7, _line0, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAlarmClock = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9289,
    cy: 12.9285,
    r: 8,
    stroke: "#315373",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9289,
    cy: 12.9285,
    r: 2,
    fill: "#315373"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53553 3.46447C8.59785 2.52678 7.32608 2 6 2C4.67392 2 3.40215 2.52678 2.46447 3.46447C1.52678 4.40215 1 5.67392 1 7C1 8.32608 1.52678 9.59785 2.46447 10.5355L9.53553 3.46447Z",
    fill: "#315373"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4644 3.46447C15.4021 2.52678 16.6739 2 18 2C19.326 2 20.5978 2.52678 21.5355 3.46447C22.4732 4.40215 23 5.67392 23 7C23 8.32608 22.4732 9.59785 21.5355 10.5355L14.4644 3.46447Z",
    fill: "#315373"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.92892,
    y1: 20.0498,
    x2: 5.05025,
    y2: 20.9285,
    stroke: "#315373",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 11.9289,
    y1: 8.92847,
    x2: 11.9289,
    y2: 11.9285,
    stroke: "#315373",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 15.5147,
    y1: 16.9285,
    x2: 11.9289,
    y2: 13.3427,
    stroke: "#315373",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: -1.5,
    x2: 2.74264,
    y2: -1.5,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 17.9289 17.9285)",
    stroke: "#315373",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 6.17892,
    y1: 12.6785,
    x2: 6.67892,
    y2: 12.6785,
    stroke: "#315373",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 17.1789,
    y1: 12.6785,
    x2: 17.6789,
    y2: 12.6785,
    stroke: "#315373",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9289 18.6785L11.9289 18.1785",
    stroke: "#315373",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9289 7.67847L11.9289 7.17847",
    stroke: "#315373",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 8.83742,
    y1: 17.7832,
    x2: 9.08742,
    y2: 17.3502,
    stroke: "#315373",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4289 8.42847L14.666 7.98827",
    stroke: "#315373",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 7.07439,
    y1: 9.83696,
    x2: 7.5074,
    y2: 10.087,
    stroke: "#315373",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8422 15.4285L17.2674 15.6916",
    stroke: "#315373",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 9.27055,
    y1: 7.82368,
    x2: 9.52055,
    y2: 8.2567,
    stroke: "#315373",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9289 17.4285L15.166 17.8687",
    stroke: "#315373",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 6.82439,
    y1: 15.5865,
    x2: 7.2574,
    y2: 15.3365,
    stroke: "#315373",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4289 10.1721L16.8541 9.90901",
    stroke: "#315373",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAlarmClock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/alarm-clock.b3f7e107.svg";
export { ForwardRef as ReactComponent };